import { css } from '@emotion/react'
import { ComponentPropsWithoutRef, useState } from 'react'

import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

import { Newsletter } from './Newsletter'

interface Props extends ComponentPropsWithoutRef<'section'> {
  data?: readonly (Queries.NewsletterFragment | null)[] | null
  latestHeading:
    | NonNullable<
        Queries.NewsletterPageQuery['datoCmsNewsletterPage']
      >['latestHeading']
    | null
    | undefined
}

export const NewslettersSection = ({
  data,
  latestHeading,
  ...props
}: Props): JSX.Element => {
  const [recordsToShow, setRecordsToShow] = useState(25)
  const handleShowMore = () => {
    if (data && recordsToShow < data?.length) {
      setRecordsToShow(prev => prev + 24)
    }
  }
  const styles = {
    section: css`
      background: #fff;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: var(--gtr-36);
      grid-row-gap: var(--row-54);
      padding: var(--row-36) var(--margin) var(--row-108);
      ${mq().m} {
        grid-template-columns: repeat(3, 1fr);
      }
      ${mq().s} {
        grid-template-columns: 1fr 1fr;
      }
    `,
    showMoreButton: css`
      grid-column: 1 / -1;
      justify-self: center;
      color: ${colors.gray45};
      text-transform: uppercase;
      font-size: var(--fs-18);
      border: 2px currentColor solid;
      padding: 0.5em 0.75em;
      font-weight: 500;
      @media (hover: hover) {
        &:hover {
          color: ${colors.red};
        }
      }
      ${data &&
      recordsToShow >= data?.length &&
      css`
        display: none;
      `}
    `,
  }
  return (
    <section
      css={styles.section}
      {...props}
    >
      {data?.slice(0, recordsToShow).map((newsletter, i) => (
        <Newsletter
          data={newsletter}
          layout={i === 0 ? 'FEATURED' : 'DEFAULT'}
          latestHeading={latestHeading}
          key={i}
        />
      ))}
      <button
        css={styles.showMoreButton}
        onClick={handleShowMore}
      >
        Show More
      </button>
    </section>
  )
}
